
<!-- Header -->
<div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300 -mx-4 sticky top-0 left-0 surface-0 z-5">
  <h2 class="mb-0 text-sm">{{ header | translate}}</h2>
  <i class="fa fa-times text-xl cursor-pointer text-500 ml-3"  (click)="ref.close()"></i>
</div>
<!-- Header -->

<!-- Content -->

<div class="p-3 md:flex -mx-4">
  <div class="w-12 md:w-8">

    <image-cropper
    class="md:h-25rem"
      *ngIf="imageFile"
      [imageFile]="imageFile"
      [maintainAspectRatio]="true"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [aspectRatio]="aspectRatio"
      [resizeToWidth]="256"
      [cropperMinWidth]="128"
      [onlyScaleDown]="true"
      [roundCropper]="roundCropper"
      [canvasRotation]="canvasRotation"
      [transform]="transform"
      [alignImage]="'left'"
      [style.display]="showCropper ? null : 'none'"
      format="png"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady($event)"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  
  </div>
  <div class="md:w-4">
    <h5 class="text-sm my-3 md:mt-0">{{'common.IMAGE_CROP.PREVIEW' | translate}}</h5>
    <img
      [src]="croppedImage"
      [style.border]="croppedImage ? '1px solid var(--gray-300)' : 'none'"
    />
  </div>
</div>
<!-- Content -->

<!-- Modal Footer -->
<div class="px-3 pt-3 -mb-2 -mx-4 border-top-1 border-300 surface-0 z-5 flex align-items-center justify-content-between">
    <p-button (click)="ref.close()" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT'| translate" styleClass="p-button-link text-sm"></p-button>
    <p-button styleClass="text-sm" (click)="doneCropping()" [label]="'common.BUTTONS.BUTTON-TEXT-SAVE'| translate"></p-button>
</div>
